export const DEPARTMENTS = [
  "Management",
  "Marketing & Communications",
  "Sales & Business Development",
  "Operations & Customer Success",
  "People & Culture",
  "Finance & Compliance",
  "Innovation & Product Development",
  "Administration & Logistics",
];

// Sub-Departments are strictly dependent on the selected Department.
export const SUB_DEPARTMENTS = {
  "Management": ["Strategic Leadership", "Business Planning & Growth"],
  "Marketing & Communications": ["Brand & Communications", "Digital Marketing", "Content & Creative", "Events & Outreach"],
  "Sales & Business Development": ["Sales", "Sales Support"],
  "Operations & Customer Success": ["Program Operations", "Training & Implementation Coaching"],
  "People & Culture": ["Human Resources & Employee Experience", "Learning & Development"],
  "Finance & Compliance": ["Finance & Accounting", "Payroll & Compliance", "Finance & Reporting"],
  "Innovation & Product Development": ["Product Development", "Curriculum & Content Development", "Research & Innovation", "Quality & Improvement"],
  "Administration & Logistics": ["Administration", "Procurement & Assets", "Logistics & Events"],
};

// Suggest the next LLE-### Employee ID from existing codes.
export function nextEmployeeId(users) {
  let max = 0;
  for (const u of users || []) {
    const m = /^LLE-(\d+)$/i.exec((u.employee_id || "").trim());
    if (m) max = Math.max(max, parseInt(m[1], 10));
  }
  return `LLE-${String(max + 1).padStart(3, "0")}`;
}
